module.exports = __webpack_public_path__ + "static/img/tf.3ac7412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimg/tf.png
// module id = yAnP
// module chunks = 4